import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Import components
import LandingPage from './pages/LandingPage';
import { CustomerAuth, AdminLogin } from './pages/Auth';
import CustomerDashboard from './pages/CustomerDashboard';
import AdminDashboard from './pages/AdminDashboard';

// NEW IMPORTS
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

// Protected Route Logic
const ProtectedRoute = ({ children, role }) => {
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('role');
  
  if (!token) return <Navigate to="/login" replace />;
  if (role && userRole !== role) return <Navigate to="/" replace />;
  
  return children;
};

export default function App() {
  return (
    <Router>
      <div className="font-sans text-gray-900 selection:bg-indigo-100 selection:text-indigo-700">
        <Routes>

          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />

          {/* NEW ROUTES */}
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />

          <Route
            path="/login"
            element={
              <CustomerAuth
                onAuthSuccess={(t, r) => {
                  localStorage.setItem('token', t);
                  localStorage.setItem('role', r);
                  window.location.href = '/dashboard';
                }}
              />
            }
          />

          <Route
            path="/admin-login"
            element={
              <AdminLogin
                onAuthSuccess={(t, r) => {
                  localStorage.setItem('token', t);
                  localStorage.setItem('role', r);
                  window.location.href = '/admin-dashboard';
                }}
              />
            }
          />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute role="customer">
                <CustomerDashboard
                  onLogout={() => {
                    localStorage.clear();
                    window.location.href = '/';
                  }}
                />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute role="admin">
                <AdminDashboard
                  onLogout={() => {
                    localStorage.clear();
                    window.location.href = '/';
                  }}
                />
              </ProtectedRoute>
            }
          />

          {/* Default Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}